import { render, staticRenderFns } from "./PhoneStepSection.vue?vue&type=template&id=26cbd0c1"
import script from "./PhoneStepSection.vue?vue&type=script&lang=js"
export * from "./PhoneStepSection.vue?vue&type=script&lang=js"
import style0 from "./PhoneStepSection.vue?vue&type=style&index=0&id=26cbd0c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports